import React, { Component } from 'react'
import ImageCar from '../ImageCar/ImageCar'

export class FormImage extends Component {

    state= {
        username: '',
            color : '',
            colors:  ["", "red", "blue", "green", "black", "pink"]
    }
 
    handlePseudo = e => {
        this.setState({
            username: e.target.value
        })
    }

    handleColor = event => {
        this.setState({
            username: event.target.value
        })
    }

    render() {
        return (
            <div>
                < ImageCar />
                <h1>Commentaire</h1>
                <form>
                    <div>
                        <label>Pseudo</label>
                        <input type="text" value={this.state.username} onChange={this.handlePseudo}></input>
                    </div>

                    <div>
                        <label>Couleur</label>
                        <select value={this.state.color} onChange={this.handleColor}>
                            {
                                this.state.colors.map((color, index) => {
                                    return <option key={index} value={color}>{color}</option>
                                })
                            }
                        </select>
                        
                    </div>

                   
                </form>
            </div>
        )
    }
}

export default FormImage
